import angular from 'angular';

import PaymentService from './payment.service';

export default angular
    .module('application.service.payment', [])
    .service('paymentService', PaymentService);



// WEBPACK FOOTER //
// ./src/application/service/payment/index.js